import { render, staticRenderFns } from "./AdminShowAchievement.vue?vue&type=template&id=5d9821c6&scoped=true&"
import script from "./AdminShowAchievement.vue?vue&type=script&lang=js&"
export * from "./AdminShowAchievement.vue?vue&type=script&lang=js&"
import style0 from "./AdminShowAchievement.vue?vue&type=style&index=0&id=5d9821c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9821c6",
  null
  
)

export default component.exports